import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import UserService from "services/UserService";
import axios from "axios";
import { lorawanthreadtext } from "variables/MBM/lorawanthread";
import { lorawanthreadtypeData } from "variables/MBM/lists/lorawanthread";
import moment from "moment";

import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { getLorawanthreads } from "services/ConfigServices";
import AddLorawanThread from "./AddLorawanThread";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useLorawanThreadsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1;
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getLorawanthreads(chartIdGroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [lorawanthreadsData, setLorawanthreadsData] = useState([]);
  const [lorawanthreads, setLorawanthreads] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );

        setResults(response.data);
        setLorawanthreadsData(response.data.lorawanthreads);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `lorawanthreads`, []).filter(
    (item) =>
      (item.id && (""+item.id).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.frequency && (""+item.frequency).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.servertype && lorawanthreadtypeData.find((x) => x.id == item.servertype) && lorawanthreadtypeData.find((x) => x.id == item.servertype).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastrun && moment(item.lastrun).isValid() && moment(item.lastrun).format("DD/MM/YYYY hh:mm:ss").includes(filterText)) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = lorawanthreads.map((item) => {
      let lorawanthreadexport = {};
      lorawanthreadexport[lorawanthreadtext.id] = item.id;
      lorawanthreadexport[lorawanthreadtext.servertype] = lorawanthreadtypeData.find((x) => x.id == item.servertype)?.name;
      lorawanthreadexport[lorawanthreadtext.frequency] = item.frequency;
      lorawanthreadexport[lorawanthreadtext.group] = groupInfoListById["" + item.groupid];
      lorawanthreadexport[lorawanthreadtext.lastrun] = (item.lastrun && moment(item.lastrun).isValid()) ? moment(item.lastrun).format("DD/MM/YYYY hh:mm:ss") : "";
      lorawanthreadexport[lorawanthreadtext.lastlog] = item.lastlog || "";
      return lorawanthreadexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddLorawanThread refetch={refreshTable} onClick={handleClear} />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!lorawanthreads || lorawanthreads.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, lorawanthreadsData, lorawanthreads]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setLorawanthreads
  };
}
